module.exports = __webpack_public_path__ + "img/lch.b0b94546.png";